import type { ProductToCompareI } from '../types';
import { useProductsToCompare } from './useProductsToCompare';

interface UseFetchProductComparator {
  fetching: boolean;
  productsToDisplay: ProductToCompareI[];
  fetch(): void;
}

const MAX_PRODUCTS_TO_DISPLAY = 5;
const MIN_PRODUCTS_TO_DISPLAY = 3;
/**
 * Fetches the products to compare and returns the products to display.
 *
 * To trigger the fetch, call the `fetch` function.
 * @returns {UseFetchProductComparator}
 */
export const useFetchProductComparator = (): UseFetchProductComparator => {
  const { fetching, productsToCompare, fetch } = useProductsToCompare();

  if (fetching) {
    return {
      fetching: true,
      productsToDisplay: [],
      fetch,
    };
  }

  const productsToDisplay = productsToCompare.slice(0, MAX_PRODUCTS_TO_DISPLAY);

  if (productsToDisplay.length < MIN_PRODUCTS_TO_DISPLAY)
    return {
      fetching: false,
      productsToDisplay: [],
      fetch,
    };

  return {
    fetching,
    productsToDisplay,
    fetch,
  };
};
